import { DateHelper } from "../../utilities/contracts/date-helper";

export class LookupModel {
  readonly id: number;
  readonly name: string;
  readonly description?: string;
  readonly projectTypeId?: number;
  readonly projectStatus?: number;
  readonly projectTypeName?: string;
  readonly clientId?: number;
  readonly clientName?: string;
  readonly projectRetrivalTypeId?: number;
  readonly templateID?: number;
  readonly projectLastLoadUser?: string;
  readonly projectLastLoadDate?: Date;


  constructor(options: Partial<LookupModel> = {}) {
    this.id = options.id;
    this.name = options.name;
    this.description = options.description;
    this.projectTypeId = options.projectTypeId;
    this.projectStatus = options.projectStatus;
    this.projectTypeName = options.projectTypeName;
    this.clientId = options.clientId;
    this.clientName = options.clientName;
    this.projectRetrivalTypeId = options.projectRetrivalTypeId;
    this.templateID = options.templateID;
    this.projectLastLoadUser = options.projectLastLoadUser;
    this.projectLastLoadDate = DateHelper.create(options.projectLastLoadDate, null);
  }
}
